<div class="container">
    <button [ngClass]="{'header-button-selected' : showProDetails}" class="header-button" (click)="setShowProDetails()">PRO</button>
    <button [ngClass]="{'header-button-selected' : showShows}" class="header-button" (click)="setShowShows()">SHOWS</button>
</div>